export default {
  deposit: {
    crypto: 'کرپٹو',
    fiatOrCash: 'فیاٹ/کیش',
    depositCurrency: 'ڈپازٹ کرنسی',
    chooseNetwork: 'نیٹ ورک منتخب کریں',
    depositAddress: 'ڈپازٹ پتہ',
    copy: 'کاپی کریں',
    copied: 'کاپی ہو گیا!',
    close: 'بند کریں',
    more: 'مزید',
    select: 'منتخب کریں',
    channel: 'چینل',
    loading: 'لوڈ ہو رہا ہے...',
    noCurrency: 'کوئی کرنسی دستیاب نہیں',
    bonusTip: 'پہلی ری چارج پر ڈپازٹ بونس سے لطف اندوز ہوں، 200% تک اضافی کریڈٹ کے ساتھ۔',
    minDeposit: 'کم سے کم ڈپازٹ',
    sendOnly: 'صرف {currency} اس ڈپازٹ پتے پر بھیجیں۔ {confirmations} نیٹ ورک تصدیقوں کے بعد سکّے خودکار طور پر جمع ہو جائیں گے۔',
    depositAmount: 'ڈپازٹ رقم',
    enterAmount: 'رقم درج کریں',
    confirmDeposit: 'ڈپازٹ کی تصدیق کریں',
    depositTitle: 'ڈپازٹ',
    selectChannel: 'چینل منتخب کریں',
    subtitle: 'تیز، محفوظ اور آسان',
    secureEncrypted: 'محفوظ اور مرموز',
    terms: 'جاری رکھنے سے، آپ ہماری شرائط و ضوابط سے اتفاق کرتے ہیں',
    totalDepositAmount: 'کل ڈپازٹ رقم',
    fee: 'فیس',
    arrivalAmount: 'جمع کی گئی رقم',
    payMethod: 'Payment Method',
    cpf: 'CPF',
    enterCpf: 'Please enter your CPF',
    depositSuccess: 'ڈپازٹ کامیاب!',
    depositFailed: 'ڈپازٹ ناکام، براہ کرم دوبارہ کوشش کریں۔',
    mockArrive: 'فرضی وصولی (ٹیسٹ)',
    activity: {
      firstChargeTitle: 'پہلی ری چارج رجسٹریشن ایونٹ',
      firstChargeSubtitle: 'خصوصی انعامات حاصل کرنے کے لیے اپنا پہلا ڈپازٹ رجسٹر کریں',
      dailyThreeTitle: 'روزانہ تین ری چارج',
      dailyThreeSubtitle: 'اضافی بونس حاصل کرنے کے لیے روزانہ 3 ڈپازٹ مکمل کریں',
      dailyPreviewLabel: 'پہلی ری چارج انعام',
      upTo: '{amount} {unit} تک',
      safeTitle: 'آپ کی رقم ہمارے پاس محفوظ ہے',
      safeDesc: 'ہم آپ کے لین دین اور ذاتی معلومات کے تحفظ کے لیے صنعت کی بہترین سیکیورٹی استعمال کرتے ہیں۔',
      dailyFirst: 'روزانہ پہلی ری چارج',
      dailySecond: 'روزانہ دوسری ری چارج',
      dailyThird: 'روزانہ تیسری ری چارج',
      lossReward: 'نقصان واپسی',
      lossRewardSubtitle: 'اپنے نقصانات پر کیش بیک حاصل کریں',
      rebateUpTo: '{ratio}% تک واپسی',
      notEligible: 'آپ اب اس سرگرمی میں حصہ نہیں لے سکتے',
      lossNeedSelect: 'کیش بیک میں شامل ہونے کے لیے ڈپازٹ کرتے وقت یہ سرگرمی منتخب کریں',
      claimed: 'حاصل کر لیا',
      claim: 'حاصل کریں',
      noTier: 'کوئی درجہ نہیں',
      claimWillOpen: '{time} پر حصول کھل جائے گا',
      claimTimeNotReached: 'حصول کا وقت ابھی نہیں ہوا۔ براہ کرم {time} کے بعد واپس آئیں۔',
      bonus: 'بونس',
      rebate: 'واپسی',
      depositGE: 'ڈپازٹ ≥ {amount}',
      lossGE: 'نقصان ≥ {amount}',
      claimSuccess: 'کامیابی سے حاصل کیا',
      claimFailed: 'حصول ناکام',
      alreadyClaimed: 'آپ یہ درجہ پہلے ہی حاصل کر چکے ہیں۔ دوبارہ کلک نہ کریں۔',
      lossAlreadyClaimed: 'آپ اس درجے کی نقصان واپسی پہلے ہی حاصل کر چکے ہیں۔ دوبارہ کلک نہ کریں۔',
      requireLogin: 'حصول سے پہلے لاگ ان کریں۔',
      depositNotEnough: 'آپ کی ڈپازٹ رقم ابھی شرط پوری نہیں کرتی۔ کوشش جاری رکھیں!',
      lossNotEnough: 'کل آپ کا نقصان شرط پوری نہیں کرتا۔',
      onlyHighest: 'اس سرگرمی کا انعام صرف اعلیٰ ترین سطح پر حاصل کیا جا سکتا ہے۔',
    },
  },
};
